
// 扩展 window 接口
import CallJSS from "@/Core/Bridge/CallJSS";
import ErrorMgr from "@/Fwk/ErrorMgr";
import Util from "@/Master/Util";
import DBMgr from "@/Core/DBMgr";
import RandomUtil from "@/Master/RandomUtil";
import AdjustMgr from "@/Fwk/AdjustMgr";
import AESHelper from "@/Fwk/Encrypt/AESHelper";
import DataMgr from "@/Fwk/DataMgr";
import SPlayer from "@/Master/SPlayer";
import CookieMgr from "@/Fwk/CookieMgr";
import UserMgr from "@/Core/UserMgr";
import KitAPI from "@/Fwk/Kit/KitAPI";
import KitAB from "@/Fwk/Kit/AB/KitAB";
import GameMsgUtil from "@/app/(game)/GameMsgUtil";
import KitPwa from "@/Master/PWA/KitPwa";
import FrameOrientMgr from "@/Master/FrameOrientMgr";
import AIHelp from "@/Core/AIHelp/AiHelpChat";


declare global {
    interface Window {
        callJSS?: typeof CallJSS;

        createUnityInstance?:any,
        // unityInstance?: {
        //     SendMessage: (objectName: string, methodName: string, message: string) => void;
        // };
        unityInstance:any,

        iframeWindow:any,

        KitError: typeof ErrorMgr;
        DBMgr: typeof DBMgr;
        DataMgr: typeof DataMgr;
        SPlayer: typeof SPlayer;
        RandomUtil: typeof RandomUtil;
        AdjustMgr: typeof AdjustMgr;
        AESHelper: typeof AESHelper;
        CookieMgr: typeof CookieMgr;
        UserMgr: typeof UserMgr;
        Util: typeof Util;
        KitAPI: typeof KitAPI;
        KitAB: typeof KitAB;
        GameMsgUtil: typeof GameMsgUtil;
        KitPwa: typeof KitPwa;
        FrameOrientMgr: typeof FrameOrientMgr;
        // AIHelp: typeof AIHelp;
        AIHelpSupport: typeof AIHelpSupport;
    }
}

export default class WindowGlobal {
    static Init(){
        //完整暴露出去
        if (Util.isWindow){
            window.callJSS = CallJSS;
            // window.AIHelp = AIHelp;
        }

        //测试环境使用
        if (Util.isWindow){
            window.KitError = ErrorMgr;
            window.DBMgr = DBMgr;
            window.DataMgr = DataMgr;
            window.SPlayer = SPlayer;
            window.RandomUtil = RandomUtil;
            window.AdjustMgr = AdjustMgr;
            window.AESHelper = AESHelper;
            window.CookieMgr = CookieMgr;
            window.UserMgr = UserMgr;
            window.Util = Util;
            window.KitAPI = KitAPI;
            window.KitAB = KitAB;
            window.GameMsgUtil = GameMsgUtil;
            window.KitPwa = KitPwa;
            window.FrameOrientMgr = FrameOrientMgr;
        }


    }

}